// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"7a860918","977":"f7379093"}[chunkId] + ".chunk.js";
};